import useHealthRecommendations from 'hooks/useHealthRecommendations';

export default function UnapprovedUserOverlay() {
  const { img, title, desc } = useHealthRecommendations();

  return (
    <div className='absolute left-0 z-50 grid w-full h-[calc(100%-30rem)] sm:h-[calc(100%-10rem)] top-44 sm:top-40 bg-white/50 backdrop-blur-md rounded-2xl place-items-center'>
      <div className='flex flex-col items-center justify-center w-[90vw] sm:max-w-2xl px-10 sm:px-20 py-10 mx-auto bg-white border rounded-lg shadow-lg'>
        <div className='mb-4 size-60 lg:size-72'>
          <img src={img} alt={title} className='object-cover w-full h-full' />
        </div>

        <p className='h-20 text-sm font-medium leading-none text-center text-primary sm:text-base'>
          <span className='font-semibold'>{title}: </span> {desc}
        </p>
      </div>
    </div>
  );
}
